import { render, staticRenderFns } from "./Register.vue?vue&type=template&id=4ada0fa4&scoped=true"
import script from "./Register.vue?vue&type=script&lang=js"
export * from "./Register.vue?vue&type=script&lang=js"
import style0 from "./Register.vue?vue&type=style&index=0&id=4ada0fa4&prod&lang=sass"
import style1 from "./Register.vue?vue&type=style&index=1&id=4ada0fa4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ada0fa4",
  null
  
)

export default component.exports